import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DatastoreUsernameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (/[/[:;|=,+*?<>]/.test(newValue)) {
      setError('Username cannot contain /[:;|=,+*?<>');
    } else if (newValue === '') {
      setError('Username cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Username'
          id='username'
          aria-describedby='username-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={edit}
        />
        {error ? (
          <FormHelperText id='username-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='username-helper-text'>
            Enter the datastore username
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
